import { jsx as _jsx } from "react/jsx-runtime";
import { TextInput } from '../../molecules';
export function TextareaInput(props) {
    return _jsx(TextInput, Object.assign({}, props, { multiline: true, numberOfLines: 3 }));
}
